import { cx } from "class-variance-authority";
import { useState } from "react";

import { SearchJobs } from "@/components/dashboard/SearchJobs";
import { Shortlist } from "@/components/shortlist/Shortlist";

export const DashboardPage = () => {
  const [search, setSearch] = useState("");
  const [isSearchFocused, setIsSearchFocused] = useState(false);

  return (
    <div className="flex flex-col px-2-5 py-36">
      <SearchJobs
        search={search}
        setSearch={setSearch}
        onFocusChange={setIsSearchFocused}
      />
      <div className={cx("transition-all duration-500 ease-out", isSearchFocused || search ? "mt-0" : "mt-24")}>
        {!search && <Shortlist isHidden={isSearchFocused} />}
      </div>
    </div>
  );
};
